import React from 'react';

const ConfirmModal = ({
    show,
    action,
    onClose
}) => {
    if (!show || !action) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-gray-900 rounded-xl border border-gray-800 w-full max-w-md">
                <div className="p-6">
                    <h2 className="text-xl font-bold mb-4">{action.title}</h2>
                    <p className="text-gray-400 mb-6">{action.message}</p>
                    <div className="flex gap-3 justify-end">
                        <button
                            onClick={onClose}
                            className="px-6 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={action.onConfirm}
                            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
